import {
    Store
} from 'vuex';
import {
    IGlobalState
} from '@/store';
import {
    computed
} from 'vue'
import * as Types from '@/store/action-types';

/**
 * 使用厂商列表
 */
export async function useFactoryList(store: Store<IGlobalState>,keyWord: string, page: number, limit: number) {
    // // 获取关键字
    // const keyWord = computed({
    //     get: () => store.state.factory.keyWord,
    //     set: (val) => {
    //         store.state.factory.keyWord = val;
    //     },
    // });

    // // 获取当前页码数
    // const page = computed({
    //     get: () => store.state.factory.factorys.page,
    //     set: (val) => {
    //         store.state.factory.factorys.page = val;
    //     },
    // });

    // 从接口获取厂商列表
    await store.dispatch(`factory/${Types.SET_FACTORY_LIST}`, 
    { keyWord: keyWord, 
      page: page, 
      limit: limit 
    });


    // // 获取厂商列表(包含页码数、列表数据、总页数、总条数)
    // const factorys = computed(() => store.state.factory.factorys);

    // // 如果一上来没有数据 默认从数据库获取
    // if (factorys.value.rows.length == 0) {
    //     setFactoryList();
    // }

    // async function setFactoryList() {
    //     // 从接口获取厂商列表
    //     await store.dispatch(`factory/${Types.SET_FACTORY_LIST}`, 
    //     { keyWord: keyWord, 
    //         page: page, 
    //         limit: limit 
    //     });
    // }
    // return {
    //     // keyWord,
    //     // page,
    //     factorys,
    //     setFactoryList
    // }
};